module.exports = __webpack_public_path__ + "static/img/637754fa4d68476a94053449_international-expansion-strategies-p-1600.dd2f4d8d.webp";